// ABOUTME: SPEC-82 §4.10 — the cue under Enter Boutique: a NON-interactive mic pictogram with "Voice enabled — speak to explore", and
// ABOUTME: (primer_collapsible) a "How it works" line that opens the read-first card. A cold visitor sees a hint, not a second button.

import React from 'react';
import { u } from '../../ReelChrome/railGeometry';
import { mu, muMin } from '../../ReelChrome/mobileGeometry';
import { useBreakpoint } from '../../Projectionist/useViewportSize';
import { VOICE_HINT, HOW_IT_WORKS } from '../../../uiExperiment/copy';
import { HINT, COLLAPSE, BLOCK_GAP } from './gateHintTokens';

const fontOf = (isMobile, authored, minPx) => (isMobile ? muMin(authored, minPx) : `max(${minPx}px, ${u(authored)})`);

function VoiceHintRow({ isMobile }) {
  const scale = isMobile ? mu : u;
  return (
    <div
      data-vf="voice-hint"
      className="flex items-center justify-center text-reel-chrome-textPrimary font-reel-body"
      style={{ gap: scale(HINT.iconGap), fontSize: fontOf(isMobile, HINT.font, HINT.minPx), lineHeight: HINT.leading }}
    >
      {/* Decorative: the line of text beside it carries the meaning, and a pictogram must never read as a button. */}
      <img
        src="/reel-chrome/icon-mic.svg"
        alt=""
        aria-hidden="true"
        draggable={false}
        style={{ height: scale(HINT.iconH), width: scale(HINT.iconH * HINT.glyphAspect) }}
      />
      <span>{VOICE_HINT}</span>
    </div>
  );
}

function HowItWorksLine({ isMobile, open, onToggle, controls }) {
  const scale = isMobile ? mu : u;
  return (
    <button
      type="button"
      data-vf="how-it-works"
      aria-expanded={open}
      aria-controls={controls}
      onClick={onToggle}
      className="reel-touch-target relative inline-flex items-center justify-center text-reel-chrome-textPrimary font-reel-body underline underline-offset-4 bg-transparent border-0"
      style={{
        gap: scale(COLLAPSE.chevron), padding: `0 ${scale(COLLAPSE.padX)}`,
        fontSize: fontOf(isMobile, COLLAPSE.font, COLLAPSE.minPx), lineHeight: COLLAPSE.leading,
      }}
    >
      <span>{HOW_IT_WORKS}</span>
      <span aria-hidden="true" style={{ display: 'inline-block', transform: open ? 'rotate(180deg)' : 'none' }}>⌄</span>
    </button>
  );
}

/**
 * @param {{ voiceHint: boolean, collapsible: boolean, open: boolean, onToggle: Function, controls?: string }} props
 *   `collapsible` is passed true only when the tenant HAS tutorial copy to collapse.
 */
export default function GateVoiceHint({ voiceHint, collapsible, open, onToggle, controls }) {
  const isMobile = useBreakpoint() === 'mobile';
  if (!voiceHint && !collapsible) return null;
  return (
    <div data-vf="gate-hint" className="flex flex-col items-center" style={{ gap: (isMobile ? mu : u)(BLOCK_GAP) }}>
      {voiceHint && <VoiceHintRow isMobile={isMobile} />}
      {collapsible && <HowItWorksLine isMobile={isMobile} open={open} onToggle={onToggle} controls={controls} />}
    </div>
  );
}
